import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PagedCollectionFilterResponseWrapper } from '../../classes/core/api/paged-collection-filter-response-wrapper';
import { IFilter } from '../../interfaces/filters/filter';
import { BaseApiService } from '../core/base-api.service';

@Injectable({
    providedIn: 'root'
})
export class SearchApiService {
    constructor(private baseApiService: BaseApiService) {}

    public GetSearchFilter(filtersEndpoint: string): Observable<IFilter> {
        return this.baseApiService.Get('', filtersEndpoint);
    }

    public Search<U>(
        searchEndpoint: string,
        appliedFilters: string
    ): Observable<PagedCollectionFilterResponseWrapper<U>> {
        return this.baseApiService.Get(
            '',
            `${searchEndpoint}?${appliedFilters}`
        );
    }
}
